import { APPLICANT_STAGE } from '../../../../RentalPortalApplicant'

export const QA_NAME_APPLICANT_IDENTITY_WIDGET = 'applicantIdentity'

export const QA_NAME_APPLICANT_IDENTITY_AVATAR = 'applicantIdentityAvatar'

export const QA_NAME_APPLICANT_IDENTITY_EMAIL = 'applicantIdentityEmail'

export const QA_NAME_APPLICANT_IDENTITY_EMAIL_COPY =
  'applicantIdentityEmailCopy'

export const QA_NAME_APPLICANT_IDENTITY_EMAIL_INPUT =
  'applicantIdentityEmailInput'

export const QA_NAME_APPLICANT_IDENTITY_PHONE = 'applicantIdentityPhone'

export const QA_NAME_APPLICANT_IDENTITY_PHONE_COPY =
  'applicantIdentityPhoneCopy'

export const QA_NAME_APPLICANT_IDENTITY_PHONE_INPUT =
  'applicantIdentityPhoneInput'

export const QA_NAME_APPLICANT_IDENTITY_DISCARD = 'applicantIdentityDiscard'

export const QA_NAME_APPLICANT_IDENTITY_EDIT_DISABLED =
  'applicantIdentityEditDisabled'

export const QA_NAME_APPLICANT_IDENTITY_MASKED_NOTICE =
  'applicantIdentityMaskedNotice'

export const QA_NAME_APPLICANT_IDENTITY_MESSAGE = 'applicantIdentityMessage'

export const QA_NAME_APPLICANT_IDENTITY_NAME_INPUT = 'applicantIdentityName'

export const QA_NAME_APPLICANT_IDENTITY_REVEAL = 'applicantIdentityReveal'

export const APPLICANT_IDENTITY_REVEAL_TRANSITION = APPLICANT_STAGE.screening

export const APPLICANT_IDENTITY_MESSAGE_CLAMP_LINES = 3

export const APPLICANT_IDENTITY_NAME_MAX_LENGTH = 128

export const APPLICANT_IDENTITY_PHONE_MAX_LENGTH = 32

export const APPLICANT_IDENTITY_FIELD_NAME_EMAIL = 'email'

export const APPLICANT_IDENTITY_FIELD_NAME_NAME = 'name'

export const APPLICANT_IDENTITY_FIELD_NAME_PHONE = 'phone'

export const APPLICANT_IDENTITY_CONTACT_ROWS = [
  {
    copyQaName: QA_NAME_APPLICANT_IDENTITY_EMAIL_COPY,
    emptyKey: 'RentalPortal.ApplicantProfileIdentityEmailEmptyKey',
    labelKey: 'Inhabitant.EmailLabelKey',
    name: APPLICANT_IDENTITY_FIELD_NAME_EMAIL,
    qaName: QA_NAME_APPLICANT_IDENTITY_EMAIL,
  },
  {
    copyQaName: QA_NAME_APPLICANT_IDENTITY_PHONE_COPY,
    emptyKey: 'RentalPortal.ApplicantProfileIdentityPhoneEmptyKey',
    isPhone: true,
    labelKey: 'Inhabitant.PhoneLabelKey',
    name: APPLICANT_IDENTITY_FIELD_NAME_PHONE,
    qaName: QA_NAME_APPLICANT_IDENTITY_PHONE,
  },
]

export const APPLICANT_IDENTITY_DISCARD_CONFIRMATION_PROPS = {
  description: 'RentalPortal.ApplicantProfileIdentityDiscardTextKey',
  qaName: QA_NAME_APPLICANT_IDENTITY_DISCARD,
  title: 'RentalPortal.ListingProfileBlockDiscardTitleKey',
}

export const QA_NAME_APPLICANT_IDENTITY_BREAK_GLASS_REVEAL =
  'applicantIdentityBreakGlassReveal'
